module.exports = __webpack_public_path__ + "img/paw3.27177579.svg";